import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import taxbill, { taxbillSaga } from './taxbill';
import taxbills, { taxbillsSaga } from './taxbills';


const taxIssuedModule = combineReducers({
  taxbills,
  taxbill,
});

export function* taxIssuedModuleSaga() {
  yield all([taxbillsSaga(), taxbillSaga()]);
}

export default taxIssuedModule;
